import { DrawableChartConfigDto, ContactPointChartDataDto, ContactPoint } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import { pitchCallToColor, pitchCallToTextColor, playResultToColor, playResultToTextColor } from 'utilities/colorHelpers';
import ContactPointChart from 'components/Charts/ContactPointChart/ContactPointChart';

function getGroupLabelColor(groupLabel: string, point: ContactPoint | undefined): string {
  if (point == null) {
    return pitchCallToColor[groupLabel] ?? playResultToColor[groupLabel];
  }

  return groupLabel === 'InPlay' ? playResultToColor[point.playResult] : pitchCallToColor[groupLabel];
}

function getGroupLabelTextColor(groupLabel: string, point: ContactPoint | undefined): string {
  if (point == null) {
    return pitchCallToColor[groupLabel] ?? playResultToColor[groupLabel];
  }

  return groupLabel === 'InPlay' ? playResultToTextColor[point.playResult] : pitchCallToTextColor[groupLabel];
}

const BatterSingleSessionContactPointChart = ({
  chartData,
  isLoading,
  chartConfig,
}: ChartProps<ContactPointChartDataDto, DrawableChartConfigDto>) => {
  return (
    <ContactPointChart
      chartData={chartData?.groups}
      showBufferZone={false}
      showStrikeZoneGrid={true}
      groupLabelsToSimulate={['InPlay']}
      getGroupLabelColor={getGroupLabelColor}
      getGroupLabelTextColor={getGroupLabelTextColor}
      isLoading={isLoading}
    />
  );
};

export default BatterSingleSessionContactPointChart;
